import * as Yup from "yup";

const payoneerSchemaAdmin = Yup.object({
    userId: Yup.string(),
    email: Yup.string().required("Please enter the email").email('Entered email address is invalid'),
  });
export default payoneerSchemaAdmin